var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44995 27.55H7.24995V21.75H1.44995V27.55ZM11.6 27.55H17.4V21.75H11.6V27.55ZM21.75 27.55H27.55V21.75H21.75V27.55ZM1.44995 17.4H7.24995V11.6H1.44995V17.4ZM11.6 17.4H17.4V11.6H11.6V17.4ZM21.75 17.4H27.55V11.6H21.75V17.4ZM1.44995 7.24995H7.24995V1.44995H1.44995V7.24995ZM11.6 7.24995H17.4V1.44995H11.6V7.24995ZM21.75 1.44995V7.24995H27.55V1.44995H21.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.0309109c248ede8acc40ee6d41217777.svg";
export { ForwardRef as ReactComponent };